import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["name", "value"];
import FormattedPercentage from 'I18n/components/FormattedPercentage';
import styled from 'styled-components';
import { BodySmall, LayoutHorizontal, LayoutSpaceVertical } from 'breeze-intelligence-kit';
import { ChartDonutPercentage } from 'breeze-intelligence-kit/DataViz';
import { EMPTY_LABEL } from '../../constants';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const Content = styled(LayoutSpaceVertical).withConfig({
  displayName: "MatchRateProperty__Content",
  componentId: "c3v2or-0"
})(["line-height:1.25;"]);
export const MatchRateProperty = _ref => {
  let {
      name,
      value = 0
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const displayValue = value * 100;
  return /*#__PURE__*/_jsxs(LayoutHorizontal, Object.assign({}, rest, {
    alignItems: "start",
    gap: "space-sm",
    children: [/*#__PURE__*/_jsx(ChartDonutPercentage, {
      flex: "0 0 auto",
      size: "2rem",
      value: displayValue || 0
    }), /*#__PURE__*/_jsxs(Content, {
      gap: "space-xxs",
      children: [/*#__PURE__*/_jsx(BodySmall, {
        children: name
      }), value ? /*#__PURE__*/_jsx(FormattedPercentage, {
        value: displayValue
      }) : EMPTY_LABEL]
    })]
  }));
};